import React from 'react';

import {ProteinAlignmentPanelState} from 'FileStates';
import Protein from 'molbio/proteins/Protein';
import ProteinAlignmentPanel from 'toolbar/protein/ProteinAlignmentPanel';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

class ProteinAlignmentPanelView extends ReactPanelBaseView<ProteinAlignmentPanelState, Protein> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('proteinAlignment'),
        title: 'Alignments',
        // eslint-disable-next-line @typescript-eslint/unbound-method
        component: <ProteinAlignmentPanel proteinId={this.model.id} closePanel={this.closePanel} />,
      },
    ];
  }
}

export default ProteinAlignmentPanelView;
